<h1 mat-dialog-title class="grey">{{ title }}</h1>
<mat-dialog-content class="grey dialog-button-message">{{ message }}</mat-dialog-content>
<mat-dialog-actions class="button-container d-flex flex-row justify-content-end align-content-center">
  <button mat-button (click)="dialogRef.close(false)" class="grey dialog-button-text">CANCEL</button>
  <button mat-button (click)="dialogRef.close(true)" class="grey dialog-button-text">{{ confirmAction | uppercase }}</button>
</mat-dialog-actions>
